import Menu from '~/src/common/components/Menu';

// Petite astuce pour avoir des placeholders qui se comportent comme du vrai texte.
// Utilise https://developer.mozilla.org/en-US/docs/Web/CSS/attr pour afficher le
// contenu de l'attribut `data-placeholder` dans le `:before` de l'élement, mais
// le style comme un block gris, façon skeleton (cf `./layout.ts`)
const ENTRIES = [
  'Poma Cotta, Tartae Variatae',
  'Biscottum Assortis',
  'Mellis Confecta',
  'Chocolata Nigra, Alba, Lactea',
  'Torta Domestica',
  'Pasticium Exquisitum',
  'Gelata Artificiosa',
  'Caramelum Molle, Durum',
  'Nougata Classica',
  'Pralina Delicata',
  'Fructus Dulcis Secati',
  'Panis Dulcis Recentis',
  'Moussea Citrica',
];

const CategoryMenuLoading = () => (
  <>
    <Menu desktop="primary" mobile="primary" visibility="desktop">
      <Menu.Title>
        <span data-placeholder="Dulcia et Deliciae"></span>
      </Menu.Title>
    </Menu>
    <Menu desktop="secondary" mobile="primary">
      {ENTRIES.map(entry => (
        <Menu.Entry key={entry}>
          <span data-placeholder={entry} />
        </Menu.Entry>
      ))}
    </Menu>
  </>
);

export default CategoryMenuLoading;
